import { type FC, useEffect, useState } from 'react'

import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'

import { Button } from 'components/Button/Button'
import InputCard from 'components/Form/InputCard/InputCard'
import { addToast } from 'components/Toast/Toast'
import { useModalContext } from 'context/modalContext'
import VerificationCode from 'features/VerificationCode/VerificationCode'
import { logoutUser } from 'services/endpoints/auth'
import { deactivateUser, deleteUser } from 'services/endpoints/profile'

import './_deleteAccountModal.scss'

const DeactivateAccountModal: FC<{
    type: string
}> = ({ type }) => {
    const [typeActive, setTypeActive] = useState<string>('')
    const [reason, setReason] = useState<{
        active: boolean
        text: string
    }>({
        active: false,
        text: ''
    })

    const [code, setCode] = useState('')

    const { t } = useTranslation()
    const modalData = useModalContext()
    const submitFunction = () => {
        if (code.trim() === '' || code.trim().length < 6) {
            addToast('error', t('pleaseInputVerificationCode'))
            return
        }
        addToast('loading', t('deactivatingAccount'))
        deactivateUser({ deactivate_reason: reason.text, code, status:'deactivated' }).then(resp => {
            toast.dismiss()
            if (resp.message?.original?.message === 'Wrong code!') {
                addToast('error', t('invalidCode'))
                return
            }
            modalData.clearModal()
            addToast('success', t('accountDeactivated'))
            logoutUser(('model')) // fix later
        })
    }

    useEffect(() => {
        setTypeActive(type)
    }, [type])

    if (typeActive === 'deactivate') {
        return (
            <>
                <div className='deleteAccountModal__description'>
                    {t('warningOnceYouDeactiveYourAccount')}
                </div>
                <div
                    className={`deleteAccountModal__reason deleteAccountModal__reason--${
                        reason.active ? 'active' : 'inactive'
                    }`}
                >
                    <p
                        onClick={() => {
                            setReason({ active: !reason.active, text: '' })
                        }}
                    >
                        {t('addReason')}
                    </p>
                    <InputCard
                        isTextArea={true}
                        type='text'
                        label={`${t('reason')}...`}
                        value={reason.text}
                        changeFn={(val: string) => {
                            setReason({ ...reason, text: val })
                        }}
                        customClass='deleteAccountModal__reason__input'
                    />
                </div>
                <VerificationCode changeFn={setCode} />

                <div className='deleteAccountModal__buttons'>
                    <Button
                        text={t('deactivateAccount')}
                        color='transparent'
                        type='transparent--black'
                        font='mont-14-normal'
                        height='4'
                        width='100'
                        clickFn={() => {
                            submitFunction()
                        }}
                    />

                </div>
            </>
        )
    } else {
        return (
            <>
                <div className='deleteAccountModal__description'>
                    {t('youCanDeactivateYourAccount')}
                </div>
                <div
                    className={`deleteAccountModal__reason deleteAccountModal__reason--${
                        reason.active ? 'active' : 'inactive'
                    }`}
                >
                    <p
                        onClick={() => {
                            setReason({ active: !reason.active, text: '' })
                        }}
                    >
                        {t('addReason')}
                    </p>
                    <InputCard
                        isTextArea={true}
                        type='text'
                        label={`${t('reason')}...`}
                        value={reason.text}
                        changeFn={(val: string) => {
                            setReason({ ...reason, text: val })
                        }}
                        customClass='deleteAccountModal__reason__input'
                    />
                </div>
                <VerificationCode />
                <div className='deleteAccountModal__buttons'>
                    <Button
                        text={t('deactivate')}
                        color='black'
                        font='mont-16-bold'
                        width='20'
                        height='4'
                        disabled={true}
                    />
                </div>
            </>
        )
    }
}

export default DeactivateAccountModal
